module.exports = __webpack_public_path__ + "img/banner-rivoneed.c2c9f716.webp";